<template>
    <div class="container">
        <div class="search" style="display:flex">
            <el-form ref="formRef" style="flex:1" :inline="true" :model="form" class="demo-form-inline" size="mini">
                <el-form-item label="商户CODE：" prop="code">
                    <el-input v-model.trim="form.code" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item label="企业名称：" prop="partner_name">
                    <el-input v-model.trim="form.partner_name" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item label="联系人姓名：" prop="contact_name">
                    <el-input v-model.trim="form.contact_name" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item label="联系人电话：" prop="mobile">
                    <el-input v-model.trim="form.mobile" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item label="联系人邮箱：" prop="email">
                    <el-input v-model.trim="form.email" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item label="状态：" prop="status">
                    <el-select v-model="form.status" placeholder="请选择状态" style="width: 120px;">
                        <el-option label="启用" :value="1"></el-option>
                        <el-option label="禁用" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="margin-left: 16px;" class="btnClass"
                        @click="onSearch">搜索</el-button>
                    <el-button type="text" class="textBtn" style="padding-bottom: 0px;vertical-align: bottom;"
                        @click="resetForm(formRef)">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div style="text-align: right;margin-bottom: 8px;">
            <el-button type="primary" size="small" @click="add">新建</el-button>
        </div>
        <el-table :data="list" size="mini">
            <el-table-column label="商户CODE">
                <template v-slot="scope">
                    <span>{{ scope.row.code }}</span>
                </template>
            </el-table-column>
            <el-table-column label="企业名称">
                <template v-slot="scope">
                    <span>{{ scope.row.partner_name }}</span>
                </template>
            </el-table-column>
            <el-table-column label="联系人姓名">
                <template v-slot="scope">
                    <span>{{ scope.row.contact_name }}</span>
                </template>
            </el-table-column>
            <el-table-column label="联系人邮箱">
                <template v-slot="scope">
                    <span>{{ scope.row.email }}</span>
                </template>
            </el-table-column>
            <el-table-column label="状态" width="150px">
                <template v-slot="scope">
                    <el-select v-model="scope.row.status" placeholder="请选择状态" size="mini"
                        @change="(val) => changeStatus(scope.row, val)">
                        <el-option label="启用" :value="1"></el-option>
                        <el-option label="禁用" :value="2"></el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="520px">
                <template v-slot="scope">
                    <router-link :to="'/salespartner/list/add/' + scope.row.code">
                        <el-button type="info" size="mini" class="btnClass">编辑</el-button>
                    </router-link>
                    <router-link :to="'/salespartner/list/detail/' + scope.row.code">
                        <el-button type="info" size="mini" class="btnClass" style="margin-left:10px;">详情</el-button>
                    </router-link>
                    <el-button type="primary" style="margin-left:10px;" size="mini"
                        @click="setDefaultValue(scope.row)">基础佣金设置</el-button>
                    <el-button type="success" style="margin-left:10px;" size="mini"
                        @click="setWithdrawAccount(scope.row)">提现账号设置</el-button>
                    <el-button type="warning" size="mini" @click="resetPassword(scope.row)">重置提现账号密码</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" v-model:currentPage="pagination.page"
            :page-size="pagination.limit" layout="total, prev, pager, next" :total="pagination.total" background>
        </el-pagination>
        <el-dialog v-model="withdrawAccountVisible" title="提现账号设置" width="570px">
            <el-form ref="withdrawAccountFormRef" :model="withdrawAccountForm" size="small" label-width="110px"
                :rules="withdrawAccountRules">
                <el-form-item label="银行卡账号：" prop="card_no">
                    <el-input v-model="withdrawAccountForm.card_no" autocomplete="off" />
                </el-form-item>
                <el-form-item label="银行名称：" prop="back_name">
                    <el-input v-model="withdrawAccountForm.back_name" autocomplete="off" />
                </el-form-item>
                <el-form-item label="持卡人：" prop="owner">
                    <el-input v-model="withdrawAccountForm.owner" autocomplete="off" />
                </el-form-item>
                <el-form-item label="提现密码：" prop="password" v-show="!isEdit">
                    <el-input v-model="withdrawAccountForm.password" autocomplete="off" />
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <el-button size="small" @click="withdrawAccountVisible = false">取消</el-button>
                    <el-button type="primary" size="small" @click="setWithdrawAccountConfirm(withdrawAccountFormRef)">
                        确认
                    </el-button>
                </div>
            </template>
        </el-dialog>
        <el-dialog v-model="resetPasswordVisible" title="重置提现账号密码" width="400px">
            <el-form ref="resetPasswordFormRef" :model="resetPasswordForm" size="small" label-width="70px"
                :rules="resetPasswordRules">
                <el-form-item label="密码：" prop="password">
                    <el-input v-model="resetPasswordForm.password" autocomplete="off" />
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <el-button size="small" @click="resetPasswordVisible = false">取消</el-button>
                    <el-button type="primary" size="small" @click="updatePassword(resetPasswordFormRef)">
                        确认
                    </el-button>
                </div>
            </template>
        </el-dialog>
        <el-dialog title="基础佣金设置" v-model="defaultValueVisible" width="600px" size="small">
            <el-form :model="defaultValueForm" :rules="defaultValueRules" ref="defaultValueFormRef" size="small"
                label-width="auto">
                <el-form-item label="项：" prop="item_key">
                    <el-select v-model="defaultValueForm.item_key" style="width: 240px" placeholder="请选择项">
                        <el-option label="设备激活补贴" value="sales_partner_model_device_commission"></el-option>
                        <el-option label="设备出厂补贴" value="sales_partner_model_device_factory_subsidy"></el-option>
                        <el-option label="订单佣金" value="sales_partner_model_order_commission"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="值：" prop="item_value">
                    <el-input-number v-model="defaultValueForm.item_value" :min="0" />
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button size="small" @click="defaultValueVisible = false">取消</el-button>
                    <el-button type="primary" size="small" @click="
                        setDefaultValueSubmit(defaultValueFormRef)
                        ">设置</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { onMounted, reactive, ref, toRaw, watch } from 'vue'
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'
import util from '../../../util/util'
import api from '../../../axios/api'
import md5 from 'js-md5'


const DefaultValueMap = {
    sales_partner_model_device_commission: "设备激活补贴",
    sales_partner_model_device_factory_subsidy: "设备出厂补贴",
    sales_partner_model_order_commission: "订单佣金"
}

export default {
    setup() {
        const router = useRouter()
        const form = reactive({
            code: '',
            partner_name: '',
            contact_name: '',
            mobile: '',
            email: '',
            status: '',
        })
        const pagination = reactive({
            page: 1,
            limit: 16,
            total: 0
        })
        const formRef = ref()
        const list = ref([])
        const withdrawAccountVisible = ref(false)
        const withdrawAccountForm = reactive({
            partner_code: '',
            card_no: '',
            back_name: '',
            owner: '',
            password: ''
        })
        const withdrawAccountFormRef = ref()
        const withdrawAccountRules = reactive({
            card_no: [
                { required: true, message: '请输入银行卡账号', trigger: 'blur' }
            ],
            back_name: [
                { required: true, message: '请输入银行名称', trigger: 'blur' }
            ],
            owner: [
                { required: true, message: '请输入持卡人', trigger: 'blur' }
            ],
            password: [
                { required: true, message: '请输入提现密码', trigger: 'blur' }
            ]
        })
        const isEdit = ref(true)
        const resetPasswordVisible = ref(false)
        const resetPasswordForm = reactive({
            password: '',
        })
        const resetPasswordFormRef = ref()
        const resetPasswordRules = reactive({
            password: [
                { required: true, message: '请输现密码', trigger: 'blur' }
            ],
        })
        const defaultValueForm = reactive({
            partner_code: '',
            item_key: '',
            item_name: '',
            item_value: ''
        })
        const defaultValueVisible = ref(false)
        const defaultValueFormRef = ref()
        const defaultValueList = ref([])
        const defaultValueRules = reactive({
            item_key: [
                { required: true, message: '请输入项', trigger: 'change' }
            ],
            item_value: [
                { required: true, message: '请输入值', trigger: 'blur' }
            ]
        })

        const handleCurrentChange = (val) => {
            pagination.page = val
            onSearch()
        }

        const onSearch = async () => {
            const res = await api.SalesPartnerList({ ...toRaw(form), page: pagination.page, limit: pagination.limit })
            if (res.data.code === 200) {
                const { data, page_info } = res.data.data
                list.value = data
                pagination.total = page_info.total
                pagination.page = page_info.current_page
            } else {
                ElMessage.error('查询失败: ' + res.msg)
            }
        }

        const add = () => {
            router.push('/salespartner/list/add/0')
        }

        const resetForm = formEl => {
            if (!formEl) return
            formEl.resetFields()
            onSearch()
        }

        const changeStatus = async (row, status) => {
            const res = await api.SalesPartnerUpdateStatus({ code: row.code, status })
            if (res.data.code === 200) {
                ElMessage.success('状态更新成功')
                onSearch()
            } else {
                ElMessage.error('状态更新失败: ' + res.data.msg)
            }
        }

        const setWithdrawAccount = async (row) => {
            withdrawAccountForm.partner_code = row.code
            withdrawAccountForm.password = ''
            withdrawAccountForm.card_no = ''
            withdrawAccountForm.back_name = ''
            withdrawAccountForm.owner = ''
            withdrawAccountFormRef.value?.clearValidate()
            const res = await api.SalesPartnerWithdrawAccountDetail({ partner_code: row.code })
            if (res.data.code === 200) {
                const { card_no, back_name, owner } = res.data.data
                withdrawAccountForm.card_no = card_no
                withdrawAccountForm.back_name = back_name
                withdrawAccountForm.owner = owner
                isEdit.value = !!card_no
                console.log('isEdit.value', isEdit.value)
            } else {
                isEdit.value = false
            }
            withdrawAccountVisible.value = true
        }

        const setWithdrawAccountConfirm = async (formEl) => {
            if (!formEl) return
            await formEl.validate(async (valid, fields) => {
                if (valid) {
                    try {
                        const res = await api.SalesPartnerWithdrawAccountSet({ ...toRaw(withdrawAccountForm), password: md5(withdrawAccountForm.password) })
                        if (res.data.code === 200) {
                            ElMessage.success('提现账号设置成功')
                            withdrawAccountVisible.value = false
                            onSearch()
                        } else {
                            ElMessage.error('提现账号设置失败: ' + res.data.msg)
                        }
                    } catch (error) {
                        console.log(error)
                    }
                } else {
                    console.log('error submit!', fields)
                }
            })
        }

        const resetPassword = (row) => {
            resetPasswordVisible.value = true
            resetPasswordForm.partner_code = row.code
            resetPasswordForm.password = ''
            resetPasswordFormRef.value?.clearValidate()
        }

        const updatePassword = async (formEl) => {
            if (!formEl) return
            await formEl.validate(async (valid, fields) => {
                if (valid) {
                    try {
                        const res = await api.SalesPartnerWithdrawAccountResetPassword({
                            ...toRaw(resetPasswordForm),
                            password: md5(resetPasswordForm.password)
                        })
                        if (res.data.code == 200) {
                            ElMessage.success('成功')
                            resetPasswordVisible.value = false
                            onSearch()
                        } else {
                            ElMessage.error(res.data.msg)
                        }
                    } catch (error) {
                        console.log(error)
                    }
                } else {
                    console.log('error submit!', fields)
                }
            })
        }

        const setDefaultValue = (row) => {
            defaultValueVisible.value = true
            defaultValueForm.partner_code = row.code
            defaultValueForm.item_key = ''
            defaultValueForm.item_name = ''
            defaultValueForm.item_value = ''
            defaultValueFormRef.value?.clearValidate()
        }

        const setDefaultValueSubmit = async (formEl) => {
            if (!formEl) return
            await formEl.validate(async (valid, fields) => {
                if (valid) {
                    try {
                        const res = await api.SalesPartnerModelDefaultValueSet({ ...toRaw(defaultValueForm), item_name: DefaultValueMap[defaultValueForm.item_key] })
                        if (res.data.code == 200) {
                            ElMessage.success('成功')
                            defaultValueVisible.value = false
                            onSearch()
                        } else {
                            ElMessage.error(res.data.msg)
                        }
                    } catch (error) {
                        console.log(error)
                    }
                } else {
                    console.log('error submit!', fields)
                }
            })
        }

        // 侦测isEdit变化
        watch(isEdit, (newVal, oldVal) => {
            // 设置password是否必填
            console.log(newVal, oldVal)
            if (newVal) {
                withdrawAccountRules.password = []
            } else {
                withdrawAccountRules.password = [
                    { required: true, message: '请输入提现密码', trigger: 'blur' }
                ]
            }
        }, { immediate: true })

        onMounted(() => {
            onSearch()
        })

        return {
            form,
            onSearch,
            list,
            formRef,
            pagination,
            handleCurrentChange,
            add,
            resetForm,
            util,
            changeStatus,
            withdrawAccountVisible,
            withdrawAccountForm,
            withdrawAccountFormRef,
            setWithdrawAccount,
            setWithdrawAccountConfirm,
            withdrawAccountRules,
            isEdit,
            resetPasswordVisible,
            resetPasswordForm,
            resetPasswordFormRef,
            resetPasswordRules,
            resetPassword,
            updatePassword,
            setDefaultValue,
            defaultValueVisible,
            defaultValueList,
            defaultValueForm,
            defaultValueRules,
            defaultValueFormRef,
            setDefaultValueSubmit
        }
    }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.container {
	font-family: 'Manrope';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	.search {
		background: #F0F2F5;
		padding-top: 16px;
		margin-bottom: 24px;
	}
	.el-form {
		::v-deep(.el-form-item__label) {
			font-family: 'Manrope';
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			color: #000000;
            opacity: 0.8;
			padding-right: 0px;
		}
		.el-form-item {
			margin-left: 24px;
		}
	}
	.btnClass {
		color: #FFF;
		background-color: #FB6D07;
		border-color: #FB6D07;
	}
	.textBtn {
		color: #FB6D07;
	}
	::v-deep(thead) {
		font-family: 'Manrope';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #000;
		opacity: 0.8;
		th {
			font-weight: 400;
			background-color: #F0F2F5;
		}
	}
  ::v-deep(tbody) {
    tr {
      font-family: 'Manrope';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      opacity: 0.8;
    }
  }

}
</style>
